import React, { useMemo } from 'react';
import icon4 from '../assets/images/newicon4.svg';
import icon5 from '../assets/images/newicon5.svg';
import icon6 from '../assets/images/newicon6.svg';
import icon7 from '../assets/images/newicon7.svg';
import icon8 from '../assets/images/newicon8.svg';

const ICONS = [icon4, icon5, icon6, icon7, icon8];

const assignIcons = (count) => {
  if (!count) return [];
  const pool = [...ICONS];
  const selection = [];

  for (let i = 0; i < count; i += 1) {
    if (!pool.length) {
      pool.push(...ICONS);
    }

    const randomIndex = Math.floor(Math.random() * pool.length);
    const [icon] = pool.splice(randomIndex, 1);
    selection.push(icon);
  }

  return selection;
};

const ServiceDetailCards = ({ items = [] }) => {
  const cardIcons = useMemo(() => assignIcons(items.length), [items.length]);

  if (!items.length) {
    return null;
  }

  return (
    <section className="section services-grid service-details">
      <div className="wrapper">
        <div className="service-detail-cards">
          {items.map((item, index) => (
            <div className="service-detail-card" key={`${item.title}-${index}`}>
              <div className="service-detail-card__icon" aria-hidden="true">
                {cardIcons[index % cardIcons.length] && (
                  <img src={cardIcons[index % cardIcons.length]} alt="" draggable="false" />
                )}
              </div>
              <div className="service-detail-card__header">
                <h3 className="service-detail-card__title">{item.title}</h3>
              </div>
              <p className="service-detail-card__description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceDetailCards;
